"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var eligibility_1 = require("@bhtp-client-api/eligibility");
var base_1 = require("@bhtp-client-api/base");
var validators_1 = require("./../validators");
var view_models_1 = require("./../view-models");
var misc_1 = require("./../misc");
var moment = require("moment");
var FlightInputControlNames = (function () {
    function FlightInputControlNames() {
    }
    return FlightInputControlNames;
}());
FlightInputControlNames.flightDate = 'flightDate';
FlightInputControlNames.airline = 'airline';
FlightInputControlNames.flightNumber = 'flightNumber';
FlightInputControlNames.flightInfo = 'flightInfo';
FlightInputControlNames.departureAirport = 'departureAirport';
FlightInputControlNames.arrivalAirport = 'arrivalAirport';
FlightInputControlNames.doNotVerify = 'doNotVerify';
exports.FlightInputControlNames = FlightInputControlNames;
var FlightInputComponent = (function () {
    function FlightInputComponent(formBuilder, eligibilityService) {
        this.formBuilder = formBuilder;
        this.eligibilityService = eligibilityService;
        this.required = true;
        this.validationOverride = false;
        this.acknowledgementsCleared = new core_1.EventEmitter();
        this.flightIsBeforeToday = false;
        this.formInitialized = false;
        this.lastRequest = null;
        this.searchResults = [];
        this.flightDateMessage = 'Your flight information is outside of the trip dates you submitted. Please recheck your information.';
        this.placeHolderOption = -1;
        this.validationMessages = this.buildValidationMessages();
    }
    FlightInputComponent.prototype.ngOnChanges = function (changes) {
        if (this.form && this.flight && !this.formInitialized) {
            this.buildForm();
        }
        else if (this.formInitialized && (changes['minDate'] || changes['maxDate'])) {
            this.updateDatesToCheck();
            this.validationMessages = this.buildValidationMessages();
        }
    };
    FlightInputComponent.prototype.ngOnDestroy = function () {
        if (this.flightSearchSubscription && !this.flightSearchSubscription.closed) {
            this.flightSearchSubscription.unsubscribe();
        }
    };
    FlightInputComponent.prototype.buildForm = function () {
        // if no min date provided, use tomorrow as the min date
        if (!this.minDate) {
            this.minDate = moment().add(1, 'day').startOf('day').format(validators_1.Constants.DATE_PARSE_FORMAT);
            this.flightDateMessage = 'Flight Date must be a valid date in the future.';
            this.validationMessages = this.buildValidationMessages();
        }
        var flightIsRequired = this.required || this.flightHasSomeValues(this.flight);
        var flightDate = this.formBuilder.control(this.flight.flightDate, this.getFlightDateValidators(flightIsRequired));
        var airline = this.formBuilder.control(this.flight.airline && this.flight.airline.name ? this.flight.airline : '', this.getAirlineValidators(flightIsRequired));
        var flightNumber = this.formBuilder.control(this.flight.flightNumber, this.getFlightNumberValidators(flightIsRequired));
        this.form.addControl(FlightInputControlNames.flightDate, flightDate);
        this.form.addControl(FlightInputControlNames.airline, airline);
        this.form.addControl(FlightInputControlNames.flightNumber, flightNumber);
        this.form.addControl(FlightInputControlNames.flightInfo, this.formBuilder.control({ value: this.flight.flightInfo, disabled: true }, forms_1.Validators.compose([forms_1.Validators.required, validators_1.doesNotEqualNegativeOneValidator()])));
        this.form.addControl(FlightInputControlNames.departureAirport, this.formBuilder.control(this.flight.departureAirport, [forms_1.Validators.required]));
        this.form.addControl(FlightInputControlNames.arrivalAirport, this.formBuilder.control(this.flight.arrivalAirport, [forms_1.Validators.required]));
        this.form.addControl(FlightInputControlNames.doNotVerify, this.formBuilder.control(this.flight.doNotVerify));
        this.formInitialized = true;
        this.trackFlightInfoChanges();
        this.trackFormChanges();
        // if values are present, perform search to find flights
        this.findFlight(true);
    };
    FlightInputComponent.prototype.trackFormChanges = function () {
        var _this = this;
        // after values have changed on the form, and debounce time has passed,
        // check to see if a flight search needs to be initialized
        this.form.valueChanges.debounceTime(500).subscribe(function (value) {
            _this.flightNotFound = false;
            _this.findFlight(false);
            // resets validation for optional flights for an all or nothing check
            var flightIsRequired = _this.required || _this.flightHasSomeValues(value);
            var flightDateControl = _this.form.get(FlightInputControlNames.flightDate);
            flightDateControl.clearValidators();
            flightDateControl.setValidators(_this.getFlightDateValidators(flightIsRequired));
            flightDateControl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
            var airlineControl = _this.form.get(FlightInputControlNames.airline);
            airlineControl.clearValidators();
            airlineControl.setValidators(_this.getAirlineValidators(flightIsRequired));
            airlineControl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
            var flightNumberControl = _this.form.get(FlightInputControlNames.flightNumber);
            flightNumberControl.clearValidators();
            flightNumberControl.setValidators(_this.getFlightNumberValidators(flightIsRequired));
            flightNumberControl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        });
    };
    FlightInputComponent.prototype.getFlightDateValidators = function (required) {
        var validators = [validators_1.departureDateValidator(this.maxDate, this.minDate, this.validationOverride)];
        if (required) {
            validators.push(forms_1.Validators.required);
        }
        return validators;
    };
    FlightInputComponent.prototype.getAirlineValidators = function (required) {
        var validators = [];
        if (required) {
            validators.push(forms_1.Validators.required);
        }
        return validators;
    };
    FlightInputComponent.prototype.getFlightNumberValidators = function (required) {
        var validators = [forms_1.Validators.pattern(/^[0-9]*$/)];
        if (required) {
            validators.push(forms_1.Validators.required);
        }
        return validators;
    };
    FlightInputComponent.prototype.flightHasSomeValues = function (flight) {
        var hasValues = false;
        if (flight.airline || flight.flightDate || flight.flightNumber) {
            hasValues = true;
        }
        return hasValues;
    };
    FlightInputComponent.prototype.findFlight = function (isInit) {
        var flightDateControl = this.form.controls[FlightInputControlNames.flightDate];
        var airlineControl = this.form.controls[FlightInputControlNames.airline];
        var flightNumberControl = this.form.controls[FlightInputControlNames.flightNumber];
        // if the values required to search for a flight are valid, run the flight search
        if (flightDateControl && airlineControl && flightNumberControl &&
            flightDateControl.valid && airlineControl.valid && flightNumberControl.valid) {
            var flightDate = flightDateControl.value;
            var airline = airlineControl.value;
            var flightNumber = flightNumberControl.value;
            if (airline && airline.name) {
                // all values are valid, but departure date may be in the past, making flight search fail
                // since validation override allows for edits of policies after departure, these flights need to be marked as valid
                // do not search for flights in the past on validationOverride
                // we do not need timezone accuracy since flight view can handle flights up to 2 days in the past
                // we validate it is less than that regardless of timezone
                this.flightIsBeforeToday = moment(flightDate, '').isBefore(moment(), 'day');
                if (this.validationOverride && this.flightIsBeforeToday) {
                    // fill out search results to mock flight view finding the flight
                    // this will allow edit to proceed for edit after departure
                    // since this gets revalidated multiple times on form change, even for non flight form changes
                    // do this regardless of onInit
                    var result = {
                        departureAirportCode: this.flight.departureAirport,
                        arrivalAirportCode: this.flight.arrivalAirport,
                        flightNumber: this.flight.flightNumber,
                        flightIdentifier: '',
                        airline: this.flight.airline.name,
                        airlineCode: this.flight.airline.providerCode,
                        departureAirportCountry: '',
                        arrivalAirportCountry: '',
                        departureDate: this.flight.flightDate,
                        arrivalDate: this.flight.flightDate,
                        serviceType: ''
                    };
                    this.searchResults = [result];
                    // we know only one result is present, select it and enable the control
                    var flightInfoControl = this.form.controls[FlightInputControlNames.flightInfo];
                    // do not update the control unless changes occur, this prevents an update infinte loop
                    if (flightInfoControl.value !== 0) {
                        flightInfoControl.patchValue(0, { emitEvent: false });
                        flightInfoControl.enable();
                        flightInfoControl.updateValueAndValidity();
                    }
                    return;
                }
                var flightToCheck = new base_1.ApiFlight();
                flightToCheck.airlineCode = airline.providerCode;
                flightToCheck.departureDate = flightDate;
                flightToCheck.flightNumber = flightNumber;
                this.searchForFlight(flightToCheck, isInit);
            }
        }
        else {
            this.clearSelectedFlight();
        }
    };
    FlightInputComponent.prototype.trackFlightInfoChanges = function () {
        var _this = this;
        this.form.controls[FlightInputControlNames.flightInfo].valueChanges.debounceTime(200).subscribe(function (d) {
            // when a flight has been selected, collect the departure and return airports
            var departureAirportControl = _this.form.controls[FlightInputControlNames.departureAirport];
            var arrivalAirportControl = _this.form.controls[FlightInputControlNames.arrivalAirport];
            if (_this.searchResults && _this.searchResults.length > d && _this.form.controls[FlightInputControlNames.flightInfo].valid) {
                var selectedFlight = _this.searchResults[d];
                if (selectedFlight) {
                    departureAirportControl.patchValue(selectedFlight.departureAirportCode);
                    arrivalAirportControl.patchValue(selectedFlight.arrivalAirportCode);
                    departureAirportControl.updateValueAndValidity();
                    arrivalAirportControl.updateValueAndValidity();
                }
            }
        });
    };
    FlightInputComponent.prototype.searchForFlight = function (searchFlight, isInit) {
        var _this = this;
        // make sure duplicate requests don't occur
        var request = "" + searchFlight.departureDate + searchFlight.airlineCode + searchFlight.flightNumber;
        if (request !== this.lastRequest) {
            // clear any past acknowledgements after initialization
            if (!isInit) {
                if (this.flight.acknowledgements && this.flight.acknowledgements.length > 0) {
                    this.acknowledgementsCleared.emit(this.flight.acknowledgements);
                    this.flight.acknowledgements = [];
                }
                this.acknowledgementsCleared.emit(this.getAcknowledgements());
            }
            // saves the old flights before clearing so that we can select them if they come back in the list of flights
            var departureAirport_1 = this.form.controls[FlightInputControlNames.departureAirport].value;
            var arrivalAirport_1 = this.form.controls[FlightInputControlNames.arrivalAirport].value;
            this.clearSelectedFlight();
            // if there is a previous request in progress, ignore the response of that
            if (this.flightSearchSubscription && !this.flightSearchSubscription.closed) {
                this.flightSearchSubscription.unsubscribe();
            }
            this.checkingFlight = true;
            this.flightSearchSubscription = this.eligibilityService.searchFlights(searchFlight).subscribe(function (res) {
                _this.checkingFlight = false;
                if ((!res.messages || res.messages.length === 0) && res.response && res.response.length > 0) {
                    _this.searchResults = res.response;
                    var flightInfoControl = _this.form.controls[FlightInputControlNames.flightInfo];
                    // if there is only one flight result, select it. Otherwise make the user
                    // select the flight
                    if (_this.searchResults.length === 1) {
                        flightInfoControl.patchValue(0);
                    }
                    else {
                        var index = null;
                        if (departureAirport_1 && arrivalAirport_1) {
                            index = _this.searchResults.findIndex(function (f) { return f.departureAirportCode === departureAirport_1 &&
                                f.arrivalAirportCode === arrivalAirport_1; });
                        }
                        else {
                            index = -1;
                        }
                        flightInfoControl.patchValue(index);
                    }
                    flightInfoControl.enable();
                    flightInfoControl.updateValueAndValidity();
                }
                else {
                    _this.flightNotFound = true;
                }
            }, function (err) {
                _this.flightNotFound = true;
                _this.checkingFlight = false;
            });
            this.lastRequest = request;
        }
    };
    FlightInputComponent.prototype.clearSelectedFlight = function () {
        var departureAirportControl = this.form.controls[FlightInputControlNames.departureAirport];
        var arrivalAirportControl = this.form.controls[FlightInputControlNames.arrivalAirport];
        var flightInfoControl = this.form.controls[FlightInputControlNames.flightInfo];
        // clear previously selected flight
        this.searchResults = [];
        this.lastRequest = null;
        departureAirportControl.patchValue(null);
        arrivalAirportControl.patchValue(null);
        flightInfoControl.patchValue(null);
        flightInfoControl.disable();
        departureAirportControl.updateValueAndValidity();
        arrivalAirportControl.updateValueAndValidity();
        flightInfoControl.updateValueAndValidity();
    };
    FlightInputComponent.prototype.getAcknowledgements = function () {
        var currentValues = this.form.value;
        return misc_1.AcknowledgementService.getAcknowledgementsForFlight(currentValues, this.acknowledgements);
    };
    FlightInputComponent.prototype.updateDatesToCheck = function () {
        // update validation to check the new dates
        var flightDateControl = this.form.controls[FlightInputControlNames.flightDate];
        if (flightDateControl) {
            flightDateControl.clearValidators();
            flightDateControl.setValidators(forms_1.Validators.compose([forms_1.Validators.required, validators_1.departureDateValidator(this.maxDate, this.minDate, this.validationOverride)]));
            flightDateControl.updateValueAndValidity();
        }
    };
    FlightInputComponent.prototype.buildValidationMessages = function () {
        return {
            'flightDate': {
                'required': 'Flight Date is required.',
                'invalid': 'Flight Date must be a valid date in mm/dd/yyyy format.',
                'beforeToday': this.flightDateMessage,
                'afterMax': (this.maxDate ? "Your flight can not depart after " + this.formatDateForDisplay(this.maxDate) : this.flightDateMessage),
                'beforeMin': (this.minDate ? "Your flight can not depart before " + this.formatDateForDisplay(this.minDate) : this.flightDateMessage)
            },
            'airline': {
                'required': 'Airline is required.'
            },
            'flightNumber': {
                'required': 'Flight Number is required.',
                'pattern': 'Flight Number must be numerical.'
            },
            'flightInfo': {
                'required': 'Please select a flight.',
            }
        };
    };
    FlightInputComponent.prototype.formatDateForDisplay = function (dateString) {
        return moment(dateString).format(validators_1.Constants.DATE_DISPLAY_FORMAT);
    };
    return FlightInputComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormGroup)
], FlightInputComponent.prototype, "form", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], FlightInputComponent.prototype, "index", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], FlightInputComponent.prototype, "submitted", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", view_models_1.FlightViewModel)
], FlightInputComponent.prototype, "flight", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], FlightInputComponent.prototype, "required", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], FlightInputComponent.prototype, "validationOverride", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FlightInputComponent.prototype, "minDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FlightInputComponent.prototype, "maxDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], FlightInputComponent.prototype, "acknowledgements", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], FlightInputComponent.prototype, "acknowledgementsCleared", void 0);
FlightInputComponent = __decorate([
    core_1.Component({
        selector: 'flight-input',
        template: "<form *ngIf=\"formInitialized\" [formGroup]=\"form\">     <div>         <span class=\"loading-indicator\"><i *ngIf=\"checkingFlight\" class=\"fa fa-spinner fa-spin fa-pulse\"></i></span>         <div class=\"form-group col-md-3\">             <masked-datepicker formControlName=\"flightDate\" placeholder=\"Flight Date\" [minDate]=\"minDate\" [maxDate]=\"maxDate\"></masked-datepicker>             <validation-messages [control]=\"form.controls.flightDate\"                                     [messages]=\"validationMessages.flightDate\"                                     [submitted]=\"submitted\"></validation-messages>             <span *ngIf=\"flightNotFound\" class=\"haserrorfieldlevel\">Flight not found, please check data.</span>         </div>         <div class=\"form-group col-md-3\">             <typeahead-airline formControlName=\"airline\" [placeHolder]=\"'Airline'\"></typeahead-airline>             <validation-messages [control]=\"form.controls.airline\"                                     [messages]=\"validationMessages.airline\"                                     [submitted]=\"submitted\"></validation-messages>         </div>          <div class=\"form-group col-md-3\">             <input  class=\"form-control\"                     formControlName=\"flightNumber\"                     placeholder=\"Flight Number\"                     type=\"tel\" />             <validation-messages [control]=\"form.controls.flightNumber\"                                     [messages]=\"validationMessages.flightNumber\"                                     [submitted]=\"submitted\"></validation-messages>         </div>         <div class=\"form-group col-md-3\">             <select class=\"form-control\"                     formControlName=\"flightInfo\">                 <option [ngValue]=\"placeHolderOption\" disabled=\"disabled\" selected=\"selected\">Select a flight leg</option>                 <option *ngFor=\"let searchResult of searchResults; let i = index\" [ngValue]=\"i\">                     {{searchResult.departureAirportCode + \"  to  \" + searchResult.arrivalAirportCode}}                 </option>             </select>             <validation-messages [control]=\"form.controls.flightInfo\"                                     [messages]=\"validationMessages.flightInfo\"                                     [submitted]=\"submitted\"></validation-messages>         </div>         <acknowledgements class=\"after-form\"                                 [acknowledgements]=\"getAcknowledgements()\">         </acknowledgements>     </div> </form>",
        styles: ["\n        .loading-indicator {\n            padding: 10px;\n            margin-left: -40px;\n            float: left;\n        }\n    "]
    }),
    __metadata("design:paramtypes", [forms_1.FormBuilder, eligibility_1.BhtpEligibilityService])
], FlightInputComponent);
exports.FlightInputComponent = FlightInputComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/flight-builder/flight-input.component.js